import React from 'react';
import { formatPrice } from '@utils/utils';
import { useSelector } from 'react-redux';
import { RootState } from '@Redux/detail/store';
import styles from '../styles.module.scss';

const TaxList: React.FC = () => {
    const {
        Meals,
        VisaPriceContain,
        VisaPrice,
        AirportPriceContain,
        AirportPrice,
        StraightRemarks,
        CurrencyCode,
    } = useSelector((state: RootState) => state.groupReducer.PricesInfo!);

    //不含簽證費用+千分位
    const VisaCost = formatPrice(VisaPrice?.Cost);
    //含簽證費用+千分位
    const VisaCostContain = formatPrice(VisaPriceContain?.Cost);
    //不含機場稅+千分位
    const AirportCost = formatPrice(AirportPrice?.Cost);
    //含機場稅+千分位
    const AirportCostContain = formatPrice(AirportPriceContain?.Cost);

    const MealTypeTrans = (type: number) => {
        if (type === 1) {
            return '大人';
        } else if (type === 2) {
            return '孩童';
        } else {
            return;
        }
    };
    return (
        <ul>
            {Meals && Meals.length > 0 && (
                <li>
                    餐費：
                    {Meals.map((mealitem) => (
                        <span key={mealitem.MealType} className={styles.meals}>
                            {MealTypeTrans(mealitem.MealType)} {CurrencyCode + ' '}
                            {mealitem.Price.toLocaleString()}
                        </span>
                    ))}
                </li>
            )}
            {(VisaPrice?.Cost || VisaPriceContain?.Cost) && (
                <li>
                    簽證費：
                    {VisaPrice?.CostDesc && `費用另計 ${VisaPrice.CostDesc} `}
                    {!!VisaPrice?.Cost && ` ${CurrencyCode || 'TWD'} ${VisaCost}`}
                    {(VisaPrice?.CostDesc || VisaPrice?.Cost) &&
                        (VisaPriceContain?.CostDesc || VisaPriceContain?.Cost) &&
                        `、`}
                    {VisaPriceContain?.CostDesc && `費用包含 ${VisaPriceContain.CostDesc} `}
                    {VisaPriceContain?.Cost && ` ${CurrencyCode || 'TWD'} ${VisaCostContain}`}
                </li>
            )}
            {(AirportPrice?.Cost || AirportPriceContain?.Cost) && (
                <li>
                    機場稅：
                    {AirportPrice?.CostDesc && `費用另計 ${AirportPrice.CostDesc} `}
                    {!!AirportPrice?.Cost && ` ${CurrencyCode || 'TWD'} ${AirportCost}`}
                    {(AirportPrice?.CostDesc || AirportPrice?.Cost) &&
                        (AirportPriceContain?.CostDesc || AirportPriceContain?.Cost) &&
                        `、`}
                    {AirportPriceContain?.CostDesc && `費用包含 ${AirportPriceContain.CostDesc} `}
                    {!!AirportPriceContain?.Cost &&
                        ` ${CurrencyCode || 'TWD'} ${AirportCostContain}`}
                </li>
            )}
            {StraightRemarks && StraightRemarks.length > 0 && (
                <li className={styles['cost-item']}>
                    <span className={styles['cost-item__title']}>{` 備註：`}</span>
                    <div dangerouslySetInnerHTML={{ __html: StraightRemarks }} />
                </li>
            )}
        </ul>
    );
};

export default TaxList;
